<main>
    <div class="content">
        <div class="image-container">
            <img [src]="baseApiUrl + '/uploads/images/code_of_conduct/code_of_conduct_1.jpg'" alt="" class="main-image">
            <p class="image-text">{{ 'product.Migrant Worker Loan' | translate }}</p>
        </div>
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarNav">
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <a class="nav-link" href="/product-service/housing-loan">{{ 'product.Housing Loan' | translate }}</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="/product-service/micro-loan">{{ 'product.Micro Loan' | translate }}</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="/product-service/small-business-loan">{{ 'product.Small Business Loan' | translate }}</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="/product-service/sme-loan">{{ 'product.Small & Medium Enterprise Loan' | translate }}</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="/product-service/wash-loan">{{ 'product.WASH Loan' | translate }}</a>
                    </li>
                    <li class="nav-item active">
                      <a class="nav-link" href="/product-service/migrant-worker-loan">{{ 'product.Migrant Worker Loan' | translate }}</a>
                  </li>
                </ul>
            </div>
        </nav>
        <div class="paragraph">
            <div class="row">
                <div class="col-lg-8 col-md-8 col-sm-8 col-12">
                    <h4>{{ 'migrant_loan.Migrant Worker Loan' | translate }}</h4>
                    <h6>{{ 'migrant_loan.(Up to USD 15,000)' | translate }}</h6>
                    <p>{{ 'migrant_loan.DESCRIPTION' | translate }}​</p>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <!-- <img [src]="baseApiUrl + '/uploads/images/product_and_services/navbar_background.jpg'" alt=""> -->
                </div>
            </div>
        </div>

    </div>
    <div class="feature">
        <mat-tab-group>
            <mat-tab label="Products Features">
                <table class="table product-table table-hover">
                    <tbody>
                      <tr>
                        <td>Loan Size:</td>
                        <td>Up to USD 15,000</td>
                      </tr>
                      <tr>
                        <td>Interest Rate:</td>
                        <td>Reasonable rate</td>
                      </tr>
                      <tr>
                        <td>Loan term:</td>
                        <td>Up to 36 months</td>
                      </tr>
                      <tr>
                        <td>Collateral:</td>
                        <td>Not Required</td>
                      </tr>
                      <tr>
                        <td>Repayment mode:</td>
                        <td>Flexible</td>
                      </tr>
                      <tr>
                        <td>Landing method:</td>
                        <td>Individual loan</td>
                      </tr>
                      <tr>
                        <td>Landing currency:</td>
                        <td>USD</td>
                      </tr>
                    </tbody>
                </table>
            </mat-tab>
            <mat-tab label="Benefits">
                <div class="desc">
                    <p>Reasonable interest rate with appropriate</p>
                    <p>Repayment methodology based on customer’s business income</p>
                    <p>Fast services and friendly staff</p>
                    <p>Repayment is available at branch office, clients’ home or business partners (Wing, True Money, ACLEDA Mobile App and ABA Mobile App)</p>
                </div>
            </mat-tab>
            <mat-tab label="Requirements">
                <div class="desc">
                    <p>Be a maturity aged 18 to 65 years old</p>
                    <p>Permanent resident in NongHyup’s operation areas</p>
                    <p>Have a legal business and regular income</p>
                    <!-- <p>Have a proper collateral</p> -->
                </div>
            </mat-tab>
            <mat-tab label="How to Apply">
                <div class="desc">
                    <p>Call 023 996 023 | 023 998 226 | 017 666 036</p>
                    <p>Contact to NongHyup Finance’s branch office which is nearest your location</p>
                    <p>Visit operation areas of NongHyup Finance</p>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
    <div class="bottom-content-poster">
        <img [src]="baseApiUrl + '/uploads/images/customer_service/customer_service_1.jpg'" alt="">
        <a href="/download-app"><img [src]="baseApiUrl + '/uploads/images/mobile_download/mobile_download_1.jpg'" loading="lazy"></a>
    </div>
</main>
